import React from 'react';
import { Route } from 'react-router-dom';
import { TRANSFER, TRANSFER_TAG, TRANSFER_TAG_SUMMARY } from './paths';
import TransferTag from 'modules/TransferTag/TransferTag';
import TransferTagSummary from 'modules/TransferTag/TransferTagSummary/TransferTagSummary';
export default function TransferRoutes() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: TRANSFER
  }, /*#__PURE__*/React.createElement(TransferTag, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: TRANSFER_TAG(':tagNumber(\\d+)')
  }, /*#__PURE__*/React.createElement(TransferTag, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: TRANSFER_TAG_SUMMARY
  }, /*#__PURE__*/React.createElement(TransferTagSummary, null)));
}